import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal'
import VideoPage from "./VideoPage";

function VideoModal(props) {

    const [videoPageShow1BR, setvideoPageShow1BR] = useState(false);
    const handlevideoPageShowClose1BR = () => setvideoPageShow1BR(false);
    const handlevideoPageShow1BR = () => setvideoPageShow1BR(true);


    const [videoPageShow2BR, setvideoPageShow2BR] = useState(false);
    const handlevideoPageShowClose2BR = () => setvideoPageShow2BR(false);
    const handlevideoPageShow2BR = () => setvideoPageShow2BR(true);

    const [videoPageShow3BR, setvideoPageShow3BR] = useState(false);
    const handlevideoPageShowClose3BR = () => setvideoPageShow3BR(false);
    const handlevideoPageShow3BR = () => setvideoPageShow3BR(true);

    const [videoPageShow4BR, setvideoPageShow4BR] = useState(false);
    const handlevideoPageShowClose4BR = () => setvideoPageShow4BR(false);
    const handlevideoPageShow4BR = () => setvideoPageShow4BR(true);
    return (
        <>
            <div>
                <Modal className="videosModal" {...props}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6 p-0">
                                    <div className="videosBrImageSection">
                                        <img src="assets/images/gallery/interior/01.jpg" className="img-fluid" onClick={handlevideoPageShow1BR} />
                                        <h6>1+1</h6>
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="videosBrImageSection">
                                        <img src="assets/images/gallery/interior/01.jpg" className="img-fluid" onClick={handlevideoPageShow2BR} />
                                        <h6>2+1</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 p-0">
                                    <div className="videosBrImageSection">
                                        <img src="assets/images/gallery/interior/01.jpg" className="img-fluid" onClick={handlevideoPageShow3BR} />
                                        <h6>3+1</h6>
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="videosBrImageSection">
                                        <img src="assets/images/gallery/interior/01.jpg" className="img-fluid" onClick={handlevideoPageShow4BR} />
                                        <h6>4+1</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <VideoPage show={VideoPage} onHide={handlevideoPageShowClose1BR} />
            </div>
        </>
    )
}
export default VideoModal;